import { render, staticRenderFns } from "./CieloHeader.vue?vue&type=template&id=2ea78baa&scoped=true"
import script from "./CieloHeader.vue?vue&type=script&lang=js"
export * from "./CieloHeader.vue?vue&type=script&lang=js"
import style0 from "./CieloHeader.vue?vue&type=style&index=0&id=2ea78baa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea78baa",
  null
  
)

export default component.exports